import React, {useEffect} from "react";
import "../CoursePage.sass";

export default function Secret() {
    useEffect(() => {
        document.title = 'КьюАй - Секреты умножения';
    }, [])

    return <>
        <div>
            Центр детского развития КьюАй предлагает уникальный курс Секреты умножения, рассчитанный на детей,
            которые хотят научиться эффективно решать примеры на умножение. Дети не только познакомятся с
            техниками быстрого умножения, но и узнают о древних систем счисления, включая древнеегипетскую,
            древнегреческую, древнеиндийскую, вавилонскую и систему счисления племени майя. И все это в виде
            интересных игр, которые закрепят полученные навыки. Подарите Вашему ребенку возможность превратить
            обучение умножению чисел из скучной зубрежки в увлекательный и веселый процесс. Нервы, стресс и
            слезы - все это в прошлом, вместе с КьюАй!

        </div>
        <div className="course-footer-second">
            <div className="course-footer-second-ul">
                <div className="course-footer-second-ul-title">
                    Что получит ребёнок?
                </div>
                <ul>
                    <li>Изучение техник быстрого умножения на основе древнеегипетской, древнегреческой, древнеиндийской,
                        вавилонской, майя и других систем счисления;
                    </li>
                    <li>Доведение до автоматизма процесса умножения;</li>
                    <li>Переход от зубрежки таблицы умножения к логическому пониманию принципов умножения;</li>
                    <li>Улучшение образного мышление;</li>
                    <li>Повышение концентрации внимания;</li>
                    <li>Улучшение школьных показателей;</li>
                    <li>Формирование интереса к учебе и изучению таблицы умножения;</li>
                    <li>Повышение уровня усидчивости и мотивации к обучению.</li>
                </ul>
            </div>
            <div className="course-footer-second-img">
                <div className="course-footer-second-cy"></div>
            </div>
        </div>
        <div>
            Курс Секреты умножения в центре детского развития КьюАй – это превосходный пример того, как можно
            эффективно обучать детей в дополнение к школьному образованию. Программа курса, разработанная
            опытными педагогами, предлагает продуманный подход к обучению, где дети достигают поставленных целей
            и получают заметный результат. Кроме того, наша методика составлена с учетом необходимости
            поддержания физического и эмоционального здоровья ребенка.

        </div>
        <div>
            Родители, если вы хотите, чтобы ваш ребенок получил превосходное дополнительное образование и
            занимался с удовольствием, то курс Секреты умножения для вас. Не пропустите эту возможность для
            вашего ребенка! Наши педагоги будут рады видеть ваших деток у себя на занятиях.

        </div>
    </>
}